import { useSelector } from 'react-redux';
import './style/ProgressPanel.css';
import { tableToLayerName } from '../../../config/layerDictionary.js';
import Graphic from './Graphic';

export default function ProgressPanel() {
	const dashboardState = useSelector(state => state.dashboard);
	const { data } = dashboardState;

	const nomeTabela = tableToLayerName[data?.nomeTabelaCalculada];
	const lote = data?.lote;
	const quantidadeRegistroLote = data?.quantidadeRegistroLote;
	const quantidadeKmPlanejadoLote = data?.quantidadeKmPlanejadoLote;

	const quantidadeRegistroLoteStatus = data?.quantidadeRegistroLoteStatus;
	const registroExecutado = quantidadeRegistroLoteStatus?.['Executado'] ?? 0;
	const registroEntregue = quantidadeRegistroLoteStatus?.['Entregue'] ?? 0;
	const registroAprovado = quantidadeRegistroLoteStatus?.['Aprovado'] ?? 0;
	const registroTotal =
		registroExecutado + registroEntregue + registroAprovado;
	const statusKm = data?.quantidadeKmLoteStatus;
	const kmExecutado = statusKm?.['Executado'] ?? 0;
	const kmEntregue = statusKm?.['Entregue'] ?? 0;
	const kmAprovado = statusKm?.['Aprovado'] ?? 0;
	const kmTotal = kmExecutado + kmEntregue + kmAprovado;

	return (
		<div className="progress-panel">
			<div className="title-panel">
				<h2 className="title-label">{nomeTabela}</h2>
			</div>

			<div className="panel-content">
				{/* Parte da esquerda - Dados numéricos */}
				<div className="left-section">
					<div className="row lote">
						<div className="cell lote-label">LOTE</div>
						<div className="cell lote-value">{lote}</div>
					</div>

					<div className="row planned">
						<div className="cell planned-label">
							{[
								'Recobrimento Aerofotogramétrico',
								'Perfilamento a LASER Aerotransportado',
							].includes(nomeTabela)
								? 'Quantidade de Faixas Planejadas'
								: 'Quantidade de Blocos Planejados'}
						</div>
						<div className="cell planned-value">
							{quantidadeRegistroLote}
						</div>
					</div>
					<div className="row executed">
						<div className="cell executed-label">
							{[
								'Recobrimento Aerofotogramétrico',
								'Perfilamento a LASER Aerotransportado',
							].includes(nomeTabela)
								? 'Quantidade de Faixas Executadas'
								: 'Quantidade de Blocos Executados'}
						</div>
						<div className="cell executed-value">
							{registroTotal}
						</div>
					</div>
					<div className="row planned area-km-planned">
						<div className="cell planned-label">
							Área km² Planejada
						</div>
						<div className="cell planned-value">
							{quantidadeKmPlanejadoLote?.toLocaleString(
								'pt-BR',
								{
									minimumFractionDigits: 3,
									maximumFractionDigits: 3,
								}
							)}
						</div>
					</div>
					<div className="row executed area-km-executed">
						<div className="cell executed-label">
							Área km² Executada
						</div>
						<div className="cell executed-value">
							{kmTotal?.toLocaleString('pt-BR', {
								minimumFractionDigits: 3,
								maximumFractionDigits: 3,
							})}
						</div>
					</div>
				</div>

				{/* Parte da direita - Gráfico */}
				<div className="right-section">
					<Graphic />
				</div>
			</div>
		</div>
	);
}
